module.exports = __webpack_public_path__ + "img/edit.24c71615.svg";